var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.0001 4.41674V17.7751C9.85841 17.7751 9.70842 17.7501 9.59175 17.6834L9.55841 17.6667C7.95842 16.7917 5.16675 15.8751 3.35841 15.6334L3.11675 15.6001C2.31675 15.5001 1.66675 14.7501 1.66675 13.9501V3.88341C1.66675 2.89174 2.47508 2.14174 3.46675 2.22508C5.21675 2.36674 7.86675 3.25008 9.35008 4.17508L9.55841 4.30008C9.68341 4.37508 9.84175 4.41674 10.0001 4.41674Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 3.89128V13.9496C18.3333 14.7496 17.6833 15.4996 16.8833 15.5996L16.6083 15.633C14.7917 15.8746 11.9917 16.7996 10.3917 17.683C10.2833 17.7496 10.15 17.7746 10 17.7746V4.41628C10.1583 4.41628 10.3167 4.37462 10.4417 4.29962L10.5833 4.20795C12.0667 3.27462 14.725 2.38295 16.475 2.23295H16.525C17.5167 2.14962 18.3333 2.89128 18.3333 3.89128Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45825 7.70312H4.58325C4.24159 7.70312 3.95825 7.41979 3.95825 7.07812C3.95825 6.73646 4.24159 6.45312 4.58325 6.45312H6.45825C6.79992 6.45312 7.08325 6.73646 7.08325 7.07812C7.08325 7.41979 6.79992 7.70312 6.45825 7.70312Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08325 10.2031H4.58325C4.24159 10.2031 3.95825 9.91979 3.95825 9.57812C3.95825 9.23646 4.24159 8.95312 4.58325 8.95312H7.08325C7.42492 8.95312 7.70825 9.23646 7.70825 9.57812C7.70825 9.91979 7.42492 10.2031 7.08325 10.2031Z",
    fill: "#333548",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets);
export default __webpack_public_path__ + "static/media/Assets.7514ba8fdc9605666d3757da5a61fda0.svg";
export { ForwardRef as ReactComponent };